define(
    'viewmodels/secured/shares/share',[
        "viewmodels/ViewModelNotification",
        "plugins/router",
        "viewmodels/secured/shares/context",
        "i19n!i19n/strings"    
    ],
    function (ViewModelNotification, router, ctx, i19n) {

        var vm = new ViewModelNotification(
        {
            i19n: i19n,

            kendoGrid: null,
            $grid: null,
            listMySharedMail: ko.observable(),
            lastdays: ko.observable(30),
            id: ko.observable(""),
            title: ko.observable(""),
            subtitle: ko.observable(""),
            isGuest: ko.observable(false),
            isUser: ko.observable(false),
            isAdmin: ko.observable(false),
            isInstanceAdmin: ko.observable(false)
        });

        vm.activate = function (id) {
            vm.isGuest(vm.session.role == 0 || vm.session.role == 1 ? true : false);
            vm.isUser(vm.session.role == 2);
            vm.isAdmin(vm.session.role == 3);
            vm.isInstanceAdmin(vm.session.role == 4);

            vm.id(id);

            vm.title(id == "my" ? i19n.to.mydocumentshares : i19n.to.alldocumentshares);
            vm.subtitle(id == "my" ? i19n.to.mysharingofdocumentswith : i19n.to.allsharingofdocumentswith);

            return vm.loadData(vm.lastdays(), vm.id() == "my")
                .done(function () {
                    if (vm.kendoGrid) {                        
                        vm.kendoGrid.dataSource.read();

                        if (vm.id() == "my") {
                            vm.kendoGrid.hideColumn("sharedBy");
                        } else {
                            vm.kendoGrid.showColumn("sharedBy");
                        }
                    }
                })
                .fail(function (e) {
                    console.error(e);
                });            
        };
        vm.attached = function () {
            vm.$grid = $("#main-" + vm.id() + "share-grid");

            var debouncedFilter = _.debounce(function () { filter.call(this, vm.kendoGrid); }, 400);
            $("input", "td.filter").on("keyup", debouncedFilter);

            $(window).on("resize", _.debounce(resizeGrid, 250));

            buildKendoGrid();

            setTimeout(function () {
                resizeGrid();
            }, 500);

            function buildKendoGrid() {
                var columns = [
                    { field: "documentShareId", hidden: true, attributes: { class: "get-value" } },
                    { field: "createdDate", title: i19n.to.sharedate, width: 150, format: "{0:g}" }, //d MMM yyyy hh:mm tt
                    { field: "sharedBy", title: i19n.to.sharedby, width: 150, name: "sharedBy", hidden: vm.id() == "my"},
                    { field: "subject", title: i19n.to.subject, attributes: { "class": "subject" } },
                    { field: "documentCount", title: i19n.to.docs, width: 100 },
                    { field: "recipientCount", title: i19n.to.recipients, width: 100 },
                    { field: "downloadCount", title: i19n.to.downloads, width: 100 },
                    { field: "expiry", title: i19n.to.shareexpiry, width: 150, attributes: { "class": "expiry" }}, //d MMM yyyy hh:mm tt
                    {
                        command: [{ name: "viewdetails", text: i19n.to.viewdetails, click: showDetails },
                                  { name: "canceldetails", text: '<i class="k-icon k-delete"></i>' + i19n.to.cancel, click: cancelSharedDocument }]
                                , title: "", width: 200
                    }];                

                vm.kendoGrid = vm.$grid.kendoGrid({
                    excel: {
                        allPages: true,
                        fileName: vm.id() + "share-all.xlsx"
                    },
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    columns: columns,
                    scrollable: {
                        virtual: true
                    }
                }).data("kendoGrid");

                function showDetails(e) {
                    e.preventDefault();

                    var row = this.dataItem($(e.currentTarget).closest("tr"));

                    sessionStorage.removeItem("documentsharedid");
                    sessionStorage.setItem("documentsharedid", row.documentShareId);

                    sessionStorage.removeItem("documentsharedsubject");
                    sessionStorage.setItem("documentsharedsubject", row.subject);

                    var expiryInfo = "";
                    var created = "";                    
                    var expiry = row.expiryDate;

                    try {
                        expiryInfo = "Share Date " + kendo.toString(row.createdDate, "g"); //d MMMM h:mm tt
                    } catch (ex) { }

                    try {
                        if (row.expiry != "No Expiry") {
                            expiryInfo = expiryInfo + ", Share Expiry " + kendo.toString(new Date(row.expiryDate), "g"); //d MMMM h:mm tt
                        } else {
                            expiryInfo = expiryInfo + ", No Expiry";
                        }
                    } catch (ex) { }

                    sessionStorage.removeItem("documentsharedexpiryinfo");
                    sessionStorage.setItem("documentsharedexpiryinfo", expiryInfo);

                    router.navigate("sharedetails/" + vm.id());
                };
                function cancelSharedDocument(e) {
                    e.preventDefault();

                    //var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
                    var txtItem = $(e.currentTarget).closest("tr").find(".get-value").text();

                    ctx.cancelForSharedDocument(txtItem);

                    vm.listMySharedMail([]);

                    if (vm.$grid != null) {
                        vm.$grid.data("kendoGrid").dataSource.data([]);
                    }

                    vm.loadData(vm.lastdays(), vm.id() == "my")
                    .done(function () {
                        if (vm.kendoGrid) {
                            vm.kendoGrid.dataSource.read();
                            vm.kendoGrid.refresh();
                        }

                        setTimeout(function () {
                            resizeGrid();
                        }, 500);
                    })
                    .fail(function (e) {
                        console.error(e);
                    });
                }
            };
            function getKendoGridDataSource() {
                var schema = {
                    model: {
                        documentShareId: "documentShareId",
                        fields: {
                            documentShareId: { type: "string" },
                            createdDate: { type: "date" },
                            subject: { type: "string" },
                            documentCount: { type: "string" },
                            recipientCount: { type: "string" },
                            downloadCount: { type: "string" },
                            expiry: { type: "string" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(vm.listMySharedMail());

                            setTimeout(function () {
                                resizeGrid();
                            }, 500);
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });
            };

            $("#showall").on("click", function (e) {
                vm.kendoGrid.options.excel.fileName = vm.id() + "share-all.xlsx";

                e.preventDefault();

                vm.listMySharedMail([]);

                if (vm.kendoGrid != null) {
                    vm.kendoGrid.dataSource.data([]);
                }

                $(this).parent().addClass("active");
                $("#last30").parent().removeClass();
                $("#last90").parent().removeClass();

                vm.lastdays(11000);

                vm.loadData(vm.lastdays(), vm.id() == "my")
               .done(function () {
                   vm.kendoGrid.dataSource.read();

                   if ((vm.kendoGrid != null) && (vm.kendoGrid != undefined)) {
                       vm.kendoGrid.refresh();

                       setTimeout(function () {
                           resizeGrid();
                       }, 500);
                   }
               })
               .fail(function (ex) {
                   console.log(ex);
               });
            });
            $("#last30").on("click", function (e) {
                vm.kendoGrid.options.excel.fileName = vm.id() + "share-30.xlsx";

                e.preventDefault();

                vm.listMySharedMail([]);

                if (vm.kendoGrid != null) {
                    vm.kendoGrid.dataSource.data([]);
                }

                $(this).parent().addClass("active");
                $("#showall").parent().removeClass();
                $("#last90").parent().removeClass();

                vm.lastdays(30);

                vm.loadData(vm.lastdays(), vm.id() == "my")
               .done(function () {
                   vm.kendoGrid.dataSource.read();

                   if ((vm.kendoGrid != null) && (vm.kendoGrid != undefined)) {
                       vm.kendoGrid.refresh();

                       setTimeout(function () {
                           resizeGrid();
                       }, 500);
                   }
               })
               .fail(function (ex) {
                   console.log(ex);
               });
            });
            $("#last90").on("click", function (e) {
                vm.kendoGrid.options.excel.fileName = vm.id() + "share-90.xlsx";

                e.preventDefault();

                vm.listMySharedMail([]);

                if (vm.kendoGrid != null) {
                    vm.kendoGrid.dataSource.data([]);
                }

                $(this).parent().addClass("active");
                $("#showall").parent().removeClass();
                $("#last30").parent().removeClass();

                vm.lastdays(90);

                vm.loadData(vm.lastdays(), vm.id() == "my")
               .done(function () {
                   vm.kendoGrid.dataSource.read();

                   if (vm.kendoGrid != null && vm.kendoGrid != undefined) {
                       vm.kendoGrid.refresh();

                       setTimeout(function () {
                           resizeGrid();
                       }, 500);
                   }
               })
               .fail(function (ex) {
                   console.log(ex);
               });
            });

            function resizeGrid() {
                if (!vm.$grid)
                    return;

                var newGridHeight = $("#share-document-content").outerHeight()
                    - $(".page-header", "#share-document-content").outerHeight()
                    - 150;

                vm.$grid.height(newGridHeight);
                vm.$grid.data("kendoGrid").resize();
            }
        };
        vm.loadData = function (lastdays, isMy) {
            var d = $.Deferred();
            
            ctx.loadForSharedDocuments(lastdays, isMy)
            .done(function (data) {
                var data = mapData(data);

                data = _.sortBy(data, function (itm) { return itm.createdDate; }).reverse();

                vm.listMySharedMail(data);

                d.resolve();

                function mapData(documentInfoList) {
                    return _.map(documentInfoList, function (documentInfo) {
                        return {
                            documentShareId: documentInfo.documentShareId,
                            subject: documentInfo.subject,
                            createdDate: documentInfo.createdDate,
                            expiryDate: documentInfo.expiryDate,
                            expiry: documentInfo.expiry,
                            status: documentInfo.status,
                            shareStatus: documentInfo.shareStatus,
                            sharedByPersonId: documentInfo.sharedByPersonId,
                            sharedBy: documentInfo.sharedBy,
                            documentCount: documentInfo.documentCount,
                            recipientCount: documentInfo.recipientCount,
                            downloadCount: documentInfo.downloadCount
                        };
                    });
                };
            })
            .fail(function (e) {
                d.reject(e);

                console.error(e);
            });

            return d.promise();
        };
        vm.initialize = function () {
            if (vm.kendoGrid) {
                vm.kendoGrid.destroy();
                vm.kendoGrid = null;
                if (vm.$grid) {
                    var $parent = vm.$grid.parent();
                    var styles = vm.$grid.attr("style"); // need this so the new grid re-orders columns and resizes and overflows correctly with scrollbars.
                    vm.$grid.remove();
                    vm.$grid = vm.$originalGrid.clone();
                    vm.$grid.attr("style", styles);
                    $parent.append(vm.$grid);
                }

            }

            if (!vm.listResults())
                return;

            vm.buildKendoGrid();
        };
        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };
        vm.mySharesClick = function () {
            router.navigate("shares/my");
        };
        vm.allSharesClick = function () {
            router.navigate("shares/all");
        };
        vm.exportToExcel = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {                
                vm.kendoGrid.saveAsExcel();

                complete();
            }
        });

        return vm;

    });
